import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus } from '../../../../../../types/analytics';

interface ITrackParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  form_id: number;
  vas: string;
}

interface ITrackParamsWithDays extends ITrackParams {
  discount: number;
  days: number;
}

export const trackShowDurations = (params: ITrackParams) => {
  const { analyticsOfferStatus, form_id, vas } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'select_period_auction_sopr',
    label: 'show_period',
    page: {
      extra: {
        form_id,
        vas,
      },
    },
  });
};

export const trackDurationClick = (params: ITrackParamsWithDays) => {
  const { analyticsOfferStatus, days, discount, form_id, vas } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'select_period_auction',
    label: days === 1 ? 'select_daily' : `select_${days}days`,
    page: {
      extra: {
        // @TODO добавить price после доработок бэка
        // https://conf.cian.tech/pages/viewpage.action?pageId=1220542547
        // 27.6 $.page.extra.period_auction.price
        period_auction: { discount },
        form_id,
        vas,
      },
    },
  });
};
